import React from 'react';
import './index.less';
import { IProductsState } from '../../reducers/products-reducers';

interface PurchaseConfirmationProps {
	products: IProductsState;
}

export class PurchaseConfirmation extends React.Component<PurchaseConfirmationProps> {
	_renderSuccess(successUrl) {
		return (
			<div className="purchase-confirmation">
				<div className="container">
					<h1>Purchase complete!</h1>
					<h3>Check your email for a receipt.</h3>
					<a href={successUrl} target="_top">
						<button>Watch new content at FaithlifeTV.com</button>
					</a>
				</div>
			</div>
		);
	}

	_renderFailure(storeUrl) {
		return (
			<div className="purchase-confirmation">
				<div className="container">
					<h3>We had a problem processing your purchase.</h3>
					<a href={storeUrl} target="_top">
						<button>Please try again</button>
					</a>
				</div>
			</div>
		);
	}

	render() {
		const products = this.props.products;
		const storeUrl = products.purchaseSuccess ? null : products.failUrl;
		const successUrl = products.successUrl || '/';
		return products.purchaseSuccess ? this._renderSuccess(successUrl) : this._renderFailure(storeUrl);
	}
}
